import { render, staticRenderFns } from "./CollaboratorList.vue?vue&type=template&id=551601bd"
import script from "./CollaboratorList.vue?vue&type=script&lang=js"
export * from "./CollaboratorList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports